'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _detail = require('./detail');

var _detail2 = _interopRequireDefault(_detail);

var _overview = require('./overview');

var _news = require('./news');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.brand', []).config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    'ngInject';

    $stateProvider.state('brands', {
        parent: 'general',
        url: '/brands',
        views: {
            'main@root': {
                component: 'brandOverview'
            }
        },
        resolve: {
            brands: ["brandService", function brands(brandService) {
                return brandService.getAll();
            }]
        },
        ncyBreadcrumb: {
            label: '{{"Brands" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('brand', {
        parent: 'brands',
        url: '/{id:int}?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'brand'
            }
        },
        resolve: {
            brand: ["$stateParams", "brandService", function brand($stateParams, brandService) {
                return brandService.getById($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            pageSize: { value: '24', squash: true },
            sortProperty: { value: sortProperties['UnitPrice'].value, squash: true },
            sortAsc: { value: (sortProperties['UnitPrice'].defaultSorting === 'asc').toString(), squash: true },
            filter: { value: '', squash: true },
            breadcrumbName: ''
        },
        ncyBreadcrumb: {
            label: '{{$resolve.brand.name | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('brand-news', {
        parent: 'brand',
        url: '/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'brandNews'
            }
        },
        resolve: {
            brand: ["$stateParams", "brandService", function brand($stateParams, brandService) {
                return brandService.getById($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            categoryId: { value: '0', squash: true },
            searchValue: { value: '', squash: true }
        },
        data: {
            febelcoCustomer: true
        }
    });
    //.state('brand.product', {
    //    url: '/product/:productId',
    //    views:{
    //        'main@root':{
    //            component: 'product'
    //        }
    //    },
    //    resolve: {
    //        product: function($stateParams, productService) {
    //            return productService.get($stateParams.productId);
    //        }
    //    },
    //    reloadOnSearch : false,
    //    params: {
    //        discountId: {
    //            value: null,
    //            squash: true
    //        },
    //        loadingOverlay: true
    //    },
    //    ncyBreadcrumb: {
    //        label: '{{$resolve.product.displayName}}'
    //    }
    //});
}]).component('brand', _detail2.default).component('brandOverview', _overview.brandOverviewComponent).component('brandNews', _news.brandNewsComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/brand/index.js
// module id = 896
// module chunks = 0